/**
 * @fileoverview パスワードリセットメール送信API
 *
 * このファイルでは、パスワードリセットプロセスを開始するために
 * リセット用メールを送信するAPI連携機能を提供します。
 */

/**
 * パスワードリセット用のメールを送信する
 *
 * 指定されたメールアドレスに対して、パスワードリセット用のリンクを含む
 * メールを送信するようバックエンドAPIにリクエストします。
 * メールには、パスワードリセットページへのリンクとリセットトークンが含まれます。
 *
 * @param {string} email - パスワードリセットメールを送信する宛先メールアドレス
 * @returns {Promise<void>} メール送信成功を示すPromise
 * @throws {Error} メール送信失敗やAPI通信エラーが発生した場合
 */
import { fetchWithLog } from "./_fetchWithLog";

export const sendPasswordResetMail = async (email: string) => {
  const bffOrigin = import.meta.env.VITE_BFF_ORIGIN;

  const res = await fetchWithLog(`${bffOrigin}/v1/password/reset`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
    cache: "no-cache",
  });

  if (!res.ok) {
    throw new Error("Failed to send mail for reset password.");
  }
};
